<template>
    <div class=" mt-6 ">
      <v-layout row wrap>
        <v-flex>
          <section>
            <v-row justify="center">
              <v-col cols="6">
                <div class="text-center">
                  <v-img :src="require('@/assets/icon/verifikasi_email.png')" contain style="width: 540px; height: 360px;" class="mx-auto"></v-img>
  
                  <div class="fs-24 black_one mt-1 mb-3">
                    Hore! Registrasi Kamu Berhasil, Selanjutnya Silahkan Lakukan Verifikasi Email
                  </div>

                  <div class="fs-14 black_three">
                    Kami telah mengirimkan tautan Verifikasi ke Email  <span class="blue_one">amandapranata@gmail.com</span>  Silahkan cek Email dan segera lakukan Verifikasi agar Anda bisa masuk.
                  </div>
  
  
                  <!-- <div class="mt-7">
                    <v-btn
                      color="#240087"
                      height="40"
                      width="320"
                      elevation="0"
                      :disabled="form.mobile_key === ''"
                      style="border-radius: 6px;"
                      class="white--text text-capitalize">
                      Lanjutkan
                    </v-btn>
                  </div> -->
  
                  <div class="fs-14 black_three mt-5">
                    Email salah atau tidak menerima tautan? <span class="blue_one cursor-pointer font_weight_600">Ubah Email</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </section>
        </v-flex>
      </v-layout>
    </div>
  </template>
  
  <script>
    import { TokenService } from "@/service/Storage.Service";
    import { get, post, put, patch, destroy } from "@/service/Axios";
    export default {
      data() {
        return {
          form: {
            mobilephone: '',
            mobile_key: '',
          },
          process: {
            form: false
          },
          message: {
            success: '',
            error: ''
          }
        }
      },
      computed: {
        rps() {
          return this.$vuetify.breakpoint.name
        },
        company () {
          return this.$store.state.company
        },
        set_color () {
          return this.$store.state.color
        },
        set_color_rgb () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r}, ${g}, ${b}, 0.97)`
        },
        set_color_rgb_up () {
          let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))
  
          return `rgba(${r+35}, ${g+37}, ${b}, 0.97)`
        }
      },
      mounted () {
        
      },
      methods: {
  
      }
    }
  </script>